import { graphql } from "@graphql/__generated";

export const REQUEST_ACCOUNT_CREATION = graphql(`
  mutation requestAccountCreation(
    $firstName: String!
    $lastName: String!
    $email: String!
  ) {
    requestAccountCreation(
      firstName: $firstName
      lastName: $lastName
      email: $email
    ) {
      success
    }
  }
`);
